import { BitrixVue } from 'ui.vue';

BitrixVue.cloneComponent('Step7', 'Steps', {
	data() {
		return {
			step7: null,
			selectedDesign: 0,
			selectedDesignColor: 0,
			filteredArray: [],
			minMaxPrice: null,
			currentStyle: null,
		};
	},
	props: ['sidelines'],
	created() {
		this.getDataStep();
	},

	watch: {
		selectedDesign: function (val, oldValue) {
			this.setPropPosition({ _handleDesign: this.step7.doorHandles[val] });
			if (this.step7.doorHandles[val].colors !== undefined && this.step7.doorHandles[val].colors.length) {
				this.selectedDesignColor = 0;
				this.setPropPosition({ handleDesignColor: this.step7.doorHandles[val].colors[this.selectedDesignColor] });
			} else {
				this.selectedDesignColor = 0;
				this.setPropPosition({ handleDesignColor: 1 });
			}
		},
		selectedDesignColor: function (val) {
			if (val === null) {
				this.setPropPosition({ handleDesignColor: null });
				return;
			}
			this.setPropPosition({ handleDesignColor: this.step7.doorHandles[this.selectedDesign].colors[val] });
		},
		minMaxPrice(val) {
			this.filteredArray = this.filterDoors(this.step7.doorHandles, this.currentStyle, val);
		},
		currentStyle(val) {
			this.filteredArray = this.filterDoors(this.step7.doorHandles, val, this.minMaxPrice);
		},
		sidelines(val, oldVal) {
			if (val === undefined && val === null && oldVal === undefined && oldVal === null) return;
			if (val.id !== oldVal.id) {
				this.setFirstPoints();
			}
		},
	},
	methods: {
		isDataStep: function () {
			return this.step7;
		},
		maxPrice(list) {
			let maxPrice = 0;
			maxPrice = list.reduce((a, b) => (a > Number(b.price) ? a : Number(b.price)), maxPrice);

			return maxPrice;
		},
		minPrice(list) {
			let minPrice = 0;
			minPrice = list.reduce((a, b) => (a < Number(b.price) ? a : Number(b.price)), minPrice);
			return minPrice;
		},
		getDataStep: function () {
			let context = this;
			let store = { ...this.$store.state.position };
			delete store.renderImage;
			let req = BX.ajax.runComponentAction('mworks:configurator', 'getDataStep7', {
				mode: 'class',
				method: 'post',
				data: {
					position: store,
				},
			});

			req.catch(function (response) {
			});

			req.then((response) => {
				if (response.status == 'success') {
					context.step7 = response.data.result;
					context.setPropPosition({ _handleDesign: context.step7.doorHandles[context.selectedDesign] });
					context.setPropPosition({ handleDesignColor: context.step7.doorHandles[context.selectedDesign].colors[context.selectedDesignColor] });

					context.filteredArray = context.step7.doorHandles;

					context.minMaxPrice = [context.minPrice(context.step7.doorHandles), context.maxPrice(context.step7.doorHandles)];

					context.currentStyle = context.step7.doorStyles[0];
				}
			});
		},
		setFirstPoints() {
			const context = this;
			context.selectedDesign = 0;
			context.selectedDesignColor = 0;
			context.setPropPosition({ _handleDesign: context.step7.doorHandles[context.selectedDesign] });
			const colors = context.step7.doorHandles[context.selectedDesign].colors;
			if (colors !== undefined && colors.length) {
				context.setPropPosition({ handleDesignColor: colors[context.selectedDesignColor] });
			} else {
				context.setPropPosition({ handleDesignColor: 0 });
			}
		},
		filterDoors(arr, style, price) {
			return arr.filter((item) => {
				if (item.price >= price[0] && item.price <= price[1]) {
					if (style.toLowerCase() === 'все') return item;
					if (style.toLowerCase() === item.style.toLowerCase()) return item;
				}
			});
		},
	},
	template: `
<div class="config-block">
  <div class="config-block__inner" v-if="isDataStep()">
    <div class="config-block__wrap">
      <div class="config-block__wrap-title">Дизайн ручек</div>
      <div class="flex config-doorhandle__params mb-20">
        <Select class="maxw600:mb-15 w-100p minw600:mr-20 minw600:w-50p" label="Стиль" :options="step7.doorStyles"
          :selected="step7.doorStyles[0]" v-on:selectSelectedValue="currentStyle = $event" />
        <DoubleInputNumeric class="w-100p minw600:w-50p" :minValue="minPrice(step7.doorHandles)" :maxValue="maxPrice(step7.doorHandles)" label="Цена, руб." v-on:doubleInputValueChanged="minMaxPrice = $event">
      </div>
      <Swiper :basicSlidesPerView="1.4" :basicSpaceBetween="20" :breakpointsForSlides="3">
        <div class="swiper-slide" v-for="(slide, index) of filteredArray">
          <SimpleItem :image="slide.image" :title="slide.title" :price="slide.price" :availability="slide.availability"
            :priceType="2" :key="index" :class="{active: selectedDesign === index}"
            v-on:setActive="selectedDesign = index" />
        </div>
      </Swiper>
    </div>
    <div class="config-block__wrap mt-48" v-if="selectedDesign!==null && step7.doorHandles[selectedDesign].colors.length">
      <div class="config-block__wrap-title">Цвет ручек</div>
      <div class="flex config-row__colors">
        <Color v-for="(color, index) of step7.doorHandles[selectedDesign].colors" :class="{active: selectedDesignColor === index}" :key="index" :color="color" v-on:setActiveColor="selectedDesignColor = index" />
      </div>
    </div>
  </div>
  <div v-else>
    <div class="config-block__wrap">
      <div class="config-block__wrap-title">Дизайн ручек</div>
      <div class="flex config-doorhandle__params mb-20">
        <PuSkeleton height="75px" />
        <PuSkeleton height="75px" />
      </div>
      <Swiper :basicSlidesPerView="1.4" :basicSpaceBetween="20" :breakpointsForSlides="3">
        <div class="swiper-slide" v-for="i of [1,2,3]">
          <PuSkeleton height="280px" />
        </div>
      </Swiper>
    </div>
  </div>
</div>
`,
});
